import {
    CORE_GET_BACKEND_INFO_REQUEST,
    CORE_GET_BACKEND_INFO_SUCCESS,
    CORE_GET_BACKEND_INFO_FAILURE,
} from '../types'

// import { getAuth } from 'Lib'

const initialState = {
    user: null
}

export default {
    authen: (state = initialState, action) => {
        switch (action.type) {
            default:
                return {
                    ...state,
                    // user: getAuth()
                }
        }
    },
    backendInfo: (state = {}, action) => {
        switch (action.type) {
            case CORE_GET_BACKEND_INFO_REQUEST:
                return {}
            case CORE_GET_BACKEND_INFO_SUCCESS:
                if (action.payload && !Array.isArray(action.payload)
                    && typeof action.payload === "object") {
                    const objPayload = action.payload
                    if (!Array.isArray(objPayload.data) && typeof objPayload.data === "object") {
                        return objPayload.data
                    }
                    return {}
                } else {
                    return {}
                }
            case CORE_GET_BACKEND_INFO_FAILURE:
                return {}
            default:
                return {}
        }
    },
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/reducerAuth.js